import React, { useState, useEffect, useMemo } from 'react';
import { Button, Container, Grid, Typography } from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import AbonosTable from '../components/AbonosTable';
import { SelectBase } from 'lib.front';
import { ClienteTienda } from '../../bussines/entities/ClienteTienda';
import { estadosIniciales, filtrosAbonosPasarela } from '../../utils/constans/filtrosIniciales';
import { useClientesTienda } from '../hooks/useClientesTienda';
import { useAbonosPasarela } from '../hooks/useAbonosPasarela';
import { Pago } from '../../bussines/entities/Pago';
import { DatePicker } from '@mui/x-date-pickers';
import { useDispatch } from 'react-redux';
import { loadingModal } from 'src/redux-app';
import AbonoDetallesDialog from '../components/AbonoDetallesDialog';
import SearchIcon from '@mui/icons-material/Search';

const useStyles = makeStyles()(theme => ({
    container: {
        marginTop: theme.spacing(2)
    },
    input: {
        maxWidth: '500px',
    },
    datePicker: {
        width: '-webkit-fill-available',
        marginTop: '8px'
    }
}));

const AbonosPasarela = () => {
    const { classes, cx } = useStyles();
    const dispatch = useDispatch();

    const { getAllClientesTienda } = useClientesTienda();
    const { getSomeAbonosPasarela } = useAbonosPasarela();
    const [filtros, setFiltros] = useState(filtrosAbonosPasarela);
    const [clientes, setClientes] = useState<ClienteTienda[]>([]);
    const [dataPasarela, setDataPasarela] = useState<Pago[]>([]);
    const [estados, setEstados] = useState(estadosIniciales);
    const [isLoading, setIsLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [pagoSelected, setPagoSelected] = useState<Pago | null>(null)

    const fetchClientesTienda = async () => {
        setIsLoading(true);
        const result = await getAllClientesTienda();
        if (result) {
            setClientes(result);
        }
        setIsLoading(false);
    }

    const fetchSomeAbonosPasarela = async () => {
        setIsLoading(true);
        const result = await getSomeAbonosPasarela(filtros);
        if (result) {
            setDataPasarela(result);
        }
        setIsLoading(false);
    }

    const handleChangeFiltros = (campo: string, valor: any) => {
        setFiltros(() => {
            return { ...filtros, [campo]: valor };
        });
    };

    const verDetalles = (idPago: number) => {
        const pago = dataPasarela.find(pago => pago.idPago == idPago);
        setPagoSelected(pago || null);
        setOpenDialog(true);
    };

    //Modal de espera
    function openWaitModal(load: boolean) {
        dispatch(loadingModal(load));
    }

    useEffect(() => {
        fetchClientesTienda();
        fetchSomeAbonosPasarela();
    }, [])

    useEffect(() => {
        openWaitModal(isLoading);
    }, [isLoading]);


    return (
        <Container className={cx('containerbox', classes.container)} maxWidth="lg">
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom align="center">
                        Abonos Pasarela de Pagos
                    </Typography>
                </Grid>
                <Grid container item xs={12} spacing={1}>
                    <Grid container item md={12} lg={9} spacing={1}>
                        <Grid item xs={12} md={6} lg={3}>
                            <SelectBase
                                //@ts-ignore
                                name="cliente"
                                label="Cliente"
                                variant="outlined"
                                margin="dense"
                                onChange={(selectedOption: ClienteTienda | null) =>
                                    handleChangeFiltros('cliente', selectedOption?.idCliente)
                                }
                                options={clientes}
                                getOptionLabel={(e: ClienteTienda) => `${e.rucCliente ? e.rucCliente : e.docIdentidad} - ${e.razonSocial}`}
                                getOptionValue={(e: ClienteTienda) => e.idCliente}
                                placeholder="Selecciona un cliente"
                                fullWidth
                                isClearable
                                className={classes.input}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <DatePicker
                                name="fechaInicio"
                                label="Fecha Inicio"
                                format="dd/MM/yyyy"
                                value={filtros.fechaIni}
                                onChange={date => handleChangeFiltros('fechaIni', date)}
                                className={cx(classes.input, classes.datePicker)}
                                maxDate={filtros.fechaFin}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <DatePicker
                                name="fechaFin"
                                label="Fecha Fin"
                                format="dd/MM/yyyy"
                                value={filtros.fechaFin}
                                onChange={date => handleChangeFiltros('fechaFin', date)}
                                className={cx(classes.input, classes.datePicker)}
                                minDate={filtros.fechaIni}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <SelectBase
                                //@ts-ignore
                                name="estado"
                                label="Estado"
                                variant="outlined"
                                margin="dense"
                                onChange={(selectedOption: any) =>
                                    handleChangeFiltros('estado', selectedOption?.value)
                                }
                                options={estados}
                                className={classes.input}
                                fullWidth
                                isClearable
                                placeholder="Seleccione un estado"
                                getOptionLabel={(e: any) => e.label}
                                getOptionValue={(e: any) => e.value}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3} alignSelf='center'>
                        <Button variant="contained" fullWidth
                            onClick={fetchSomeAbonosPasarela}
                            startIcon={<SearchIcon />}
                        >
                            Buscar
                        </Button>
                    </Grid>
                </Grid>
                <Grid id="grid-tabla" item xs={12}>
                    <AbonosTable data={dataPasarela} verDetalles={verDetalles} />
                </Grid>
            </Grid>
            <AbonoDetallesDialog open={openDialog} onClose={() => setOpenDialog(false)} pago={pagoSelected} loading={setIsLoading} />
        </Container>
    );
}

export default AbonosPasarela